import Vue from 'vue'
import LocalStorageService from '../services/LocalStorageService'
import routerPermissions from './routerPermissions'

const _vm_ = new Vue({})

function isBlocked (blackList) {
  const isPlatform = LocalStorageService.isPlatform()
  const hasExcludePlatform = blackList?.includes('PLATAFORMA')

  return isPlatform && hasExcludePlatform
}

function canGoTo (toPath, userDetails) {
  const route = routerPermissions.find(permission => permission.path === toPath)

  const decorator = _vm_.$versionable.decorators.users
  const versionablePermission = decorator.hasPermission(userDetails, ...route.permissions)
  console.debug('Versionable: ' + versionablePermission) // O versionable tem um atraso para carregar ao abrir uma nova janela

  const hardCodedHasPermission = !isBlocked(route.exclude) && userDetails.permissions.some(p => route.permissions.includes(p))
  return versionablePermission || hardCodedHasPermission
}

export default canGoTo
